<template>
	<div class="row justify-xl-content-between justify-content-start align-items-center pt-2 ps-3 pb-2 mb-1 border-bottom">
		<div class="col-12 col-xl-auto order-first">
			<span class="fs-4 m-0">
				Станції катодного захисту
			</span>
		</div>
		<div class="col-auto order-2 order-xl-first me-0 pe-0">
			<span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" data-bs-title="таблиця">
				<!-- Switch to table view button -->
				<button
					type="button"
					class="btn m-0 mx-1"
					:class="{
						'btn-outline-secondary': viewType != viewTypes.table,
						'btn-secondary': viewType == viewTypes.table
					}"
					@click="switchViewTypeTo(viewTypes.table)"
					:disabled="viewType == viewTypes.table"
					style="border: 0; padding: 2px 4px 4px 4px; aspect-ratio: 1; height: 30px;"
				>
					<button-icon icon="table" color="currentColor" edge-size="20" />
				</button>
			</span>
		</div>
		<div class="col-auto order-3 order-xl-first ms-0 ps-0">
			<span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" data-bs-title="плитки">
				<!-- Switch to tiles view button -->
				<button
					type="button"
					class="btn m-0 mx-1"
					:class="{
						'btn-outline-secondary': viewType != viewTypes.tiles,
						'btn-secondary': viewType == viewTypes.tiles,
					}"
					@click="switchViewTypeTo(viewTypes.tiles)"
					:disabled="viewType == viewTypes.tiles"
					style="border: 0; padding: 2px 4px 4px 4px; aspect-ratio: 1; height: 30px;"
				>
					<button-icon icon="tiles" color="currentColor" edge-size="20" />
				</button>
			</span>
		</div>

		<div class="col-auto col-xl d-none d-xl-block">&nbsp;</div>

		<!-- Filters -->
		<div
			v-if="viewType == viewTypes.tiles && organizationCriterias.length > 0"
			class="col-xl-auto col-12 order-last order-xl"
		>
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				:criterias="organizationCriterias"
				:default-checked="sessionStore.getFilter($route.name, 'organization')"
				button-text="Організація"
				@checked-criterias="(criterias) => { saveFiters('organization', criterias) }"
			/>
		</div>
		<div
			v-if="viewType == viewTypes.tiles && departmentCriterias.length > 0"
			class="col-xl-auto col-12 order-last order-xl"
		>
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				:criterias="departmentCriterias"
				:default-checked="sessionStore.getFilter($route.name, 'department')"
				:button-text="
					accountStore.organization[accountStore.schema.organization.departmentTitle] ?
						accountStore.organization[accountStore.schema.organization.departmentTitle] :
						DEPARTMENT_TITLE
				"
				@checked-criterias="(criterias) => { saveFiters('department', criterias) }"
			/>
		</div>
		<div
			v-if="viewType == viewTypes.tiles && sectorCriterias.length > 0"
			class="col-xl-auto col-12 order-last order-xl"
		>
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				:criterias="sectorCriterias"
				:default-checked="sessionStore.getFilter($route.name, 'sector')"
				:button-text="
					accountStore.organization[accountStore.schema.organization.sectorTitle] ?
						accountStore.organization[accountStore.schema.organization.sectorTitle] :
						SECTOR_TITLE
				"
				@checked-criterias="(criterias) => { saveFiters('sector', criterias) }"
			/>
		</div>
		<div
			v-if="viewType == viewTypes.tiles"
			class="col-xl-auto col-12 order-last order-xl"
		>
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				:criterias="Station.activityVariantsText"
				:default-checked="sessionStore.getFilter($route.name, 'activity')"
				button-text="Активна"
				@checked-criterias="(criterias) => { saveFiters('activity', criterias) }"
			/>
		</div>
		<div
			v-if="viewType == viewTypes.tiles"
			class="col-xl-auto col-12 order-last order-xl"
		>
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				:criterias="Station.protectionVariantsText"
				:default-checked="sessionStore.getFilter($route.name, 'protection')"
				button-text="Захист"
				@checked-criterias="(criterias) => { saveFiters('protection', criterias) }"
			/>
		</div>
		<div
			v-if="viewType == viewTypes.tiles"
			class="col-xl-auto col-12 order-last order-xl"
		>
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				:criterias="Station.modeVariantsText"
				:default-checked="sessionStore.getFilter($route.name, 'mode')"
				button-text="Тип стаб."
				@checked-criterias="(criterias) => { saveFiters('mode', criterias) }"
			/>
		</div>

		<div class="col order-4 order-xl-last">&nbsp;</div>
		<!--  col-xl order-xl-last d-none d-xl-block -->

		<div class="col-xl-auto col-12 order-1 order-xl-last order-xl">
			<input
				v-model.trim="searchPhrase"
				type="search"
				class="form-control form-control-sm ms-0 ms-xl-auto"
				style="max-width: 15rem;"
				placeholder="Фільтрувати по назві"
				list="list-nodes"
				v-on:keydown.esc.stop="searchPhrase=''"
			/>
		</div>

		<div class="col-auto order-5 order-xl-last">
			<!-- Stations passport history button -->
			<span
				v-if="accountStore.isPrimary"
				class="mx-1 me-2"
				tabindex="0"
				data-bs-toggle="tooltip"
				data-bs-title="історія налаштувань СКЗ"
			>
				<button
					type="button"
					class="btn btn-sm btn-outline-secondary m-0 p-1"
					@click="$router.push({ name: 'stations_passport_history',})"
					style="border: 1; height: 2.4rem; aspect-ratio: 1 / 1;"
				>
					<button-icon icon="clock-history" color="currentColor" edge-size="20" />
				</button>
			</span>

			<!-- Create station button -->
			<span
				class="d-inline-block me-4"
				tabindex="0"
				data-bs-toggle="tooltip"
				data-bs-title="створити станцію"
			>
				<button
					type="button"
					class="btn btn-sm btn-outline-secondary m-0 p-2"
					style="border: 1; height: 2.4rem; aspect-ratio: 1 / 1;"
					@click="isCreatePopupOpen=true"
					:disabled="!accountStore.permissions.includes('manage_stations')"
				>
					<button-icon icon="add-station" color="currentColor" edge-size="20" />
				</button>
			</span>
		</div>
	</div>

	<h4 v-if="isNoConnectionToServer">Немає св'язку з сервером</h4>

	<Transition name="list-view">
		<stations-table
			v-if="viewType == viewTypes.table"
			:name-filter="searchPhrase"
		/>
		<stations-tiles
			v-else-if="viewType == viewTypes.tiles"
			:name-filter="searchPhrase"
		/>
	</Transition>

	<create-station-popup
		v-if="isCreatePopupOpen"
		@created="isCreatePopupOpen = false; readAllStations();"
		@close="isCreatePopupOpen = false;" @click.stop=""
	/>
</template>




<script>
import CreateStationPopup from "./CreateStationPopup.vue"
import TableFilterCheckboxes from '@/components/TableFilterCheckboxes.vue'
import StationsTable from './StationsTable.vue'
import StationsTiles from './StationsTiles.vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import { useTooltip } from '@/composables/bootstrap-tooltip.js'
import { Station } from '@/models/station.js'
import { DEPARTMENT_TITLE, SECTOR_TITLE } from '@/app.conf'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSessionStore } from '@/stores/SessionStore.js'
import { useStationsHistoryStore } from '@/stores/StationsHistoryStore.js'


export default {
	// Metrics update period
	metrics_update_rate: 60000,
	
	components: {
		CreateStationPopup,
		TableFilterCheckboxes,
		StationsTable,
		StationsTiles,
		ButtonIcon,
	},

	props: {
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const sessionStore = useSessionStore()
		const historyStore = useStationsHistoryStore()

		useTooltip()
		
		return {
			accountStore,
			stationsStore,
			sessionStore,
			historyStore,
			Station,
			DEPARTMENT_TITLE,
			SECTOR_TITLE,
		}
	},

	data() {
		return {
			updateInterval: null,

			// State flags
			isNoConnectionToServer: false,

			//
			showFilters: false,
			// For search input
			searchPhrase: '',	// search phrase
		
			// Create new station
			isCreatePopupOpen: false,
		}
	},

	async created() {
		this.historyStore.clean()
		await this.readAllStations()

		this.subscribeToUpdates()
	},

	beforeMount() {},

	mounted() {
		document.title = "Список станцій"
	},

	methods: {
		async readAllStations() {
			// console.log('Read all stations')
			// Read all stations
			await this.stationsStore.readStations((result) => {
				// console.log('Read all stations result', result)
				this.isNoConnectionToServer = !result
			})

			if (!this.isNoConnectionToServer) {
				await this.stationsStore.readMetrics((result) => {
					this.isNoConnectionToServer = !result
				})
			}
		},

		subscribeToUpdates() {
			// Clear interval if exist
			if (this.updateInterval !== null) {
				clearInterval(this.updateInterval)
				this.updateInterval = null
			}

			// Updates metrics every metrics_update_rate seconds
			this.updateInterval = setInterval(async () => {
				if (this.isNoConnectionToServer) {
					this.readAllStations()
				} else {
					this.stationsStore.readMetrics((result) => {
						this.isNoConnectionToServer = !result
					})
				}
			}, this.$options.metrics_update_rate);
		},

		switchViewTypeTo(viewType) {
			this.accountStore.switchStationsView(viewType)
			this.accountStore.save([this.accountStore.schema.settings.self,])
		},

		saveFiters(filterName, criterias) {
			// this.filters[filterName] = criterias;
			const filters = this.sessionStore.getFilter(this.$route.name, filterName);
			filters.splice(0, filters.length);
			filters.push(...criterias);
		},
	},

	computed: {
		viewType() {
			return this.accountStore.stationsView
		},

		viewTypes() {
			return this.accountStore.stationViewTypes
		},

		organizationCriterias() {
			let organizationNames = []

			this.stationsStore.stationsArray.forEach(station => {
				const name = station.passport.get(Station.passportKeys.orgName)
				if (!organizationNames.includes(name)) {
					organizationNames.push(name)
				}
			})

			return organizationNames.map((name) => name)
		},

		departmentCriterias() {
			let departmentNames = []

			this.stationsStore.stationsArray.forEach(station => {
				const department = station.passport.get(Station.passportKeys.department)
				let name = department === undefined ? "-" : department.title

				if (!departmentNames.includes(name)) {
					departmentNames.push(name)
				}
			})

			return departmentNames.map((name) => name)
		},

		sectorCriterias() {
			let sectorNames = []

			this.stationsStore.stationsArray.forEach(station => {
				const sector = station.passport.get(Station.passportKeys.sector)
				let name = sector === undefined ? "-" : sector.title
				
				if (!sectorNames.includes(name)) {
					sectorNames.push(name)
				}
			})

			return sectorNames.map((name) => name)
		},
	},

	beforeUnmount() {
		clearInterval(this.updateInterval)
		this.updateInterval = null
	},

	unmounted() {},
}
</script>




<!-- <style src="@/assets/widget.css" scoped /> -->
<style scoped>
	.list-view-enter-active,
	.list-view-leave-active {
		transition: all 0.25s ease-out;
	}

	.list-view-enter-from {
		opacity: 0;
		transform: translateY(30px);
	}

	.list-view-leave-to {
		opacity: 0;
		transform: translateY(-30px);
	}
</style>
